const Footer = () => {
  return (
    <footer className="App-footer">
      <p>
        Built with &hearts; by{" "}
        <a
          href="https://github.com/thewinniewu"
          target="_blank"
          rel="noopener noreferrer"
        >
          thewinniewu
        </a>
        <br />
        Inspired by{" "}
        <a
          href="https://aero.press/products/brew-recipe-dice"
          target="_blank"
          rel="noopener noreferrer"
        >
          James Hoffmann's Coffee Brewing Dice
        </a>{" "}
        | Aeropress icon made by{" "}
        <a
          href="https://www.flaticon.com/authors/monkik"
          target="_blank"
          rel="noopener noreferrer"
        >
          monkik
        </a>
      </p>
    </footer>
  );
};

export default Footer;
